import React from 'react';
import { RichText } from '@/app/_components/core/rich-text';
import { CardSectionElement } from '@/app/_components/shared/card-section/card-section.types';
import { cn } from '@/app/_lib/utils';

interface FeatureCardProps {
  card: CardSectionElement;
  className?: string;
}

export function FeatureCard({ card, className }: FeatureCardProps) {
  return (
    <div className={cn('flex flex-col items-center gap-4', className)}>
      {card.icon && (
        <div className="flex size-10  shrink-0 items-center justify-center rounded-md border">
          {/* eslint-disable-next-line @next/next/no-img-element -- small CMS card icon, no next/image benefit */}
          <img
            src={card.icon.url}
            alt={card.icon.altText ?? ''}
            width={16}
            height={16}
            // keep eager loading but opt out of React's automatic SSR
            // preloading so tiny icons don't compete with the LCP image
            fetchPriority="low"
            className="h-full max-h-4 w-auto max-w-4"
          />
        </div>
      )}
      {card.title && (
        <h3 className="line-clamp-3 text-center text-base/normal  font-semibold wrap-break-word">
          {card.title}
        </h3>
      )}{' '}
      {card.text && (
        <RichText
          className="mx-auto max-w-4/5 text-center md:max-w-none"
          classConfig={{
            copytext:
              'text-base leading-relaxed wrap-break-word text-muted-foreground',
          }}
        >
          {card.text}
        </RichText>
      )}
    </div>
  );
}
